import "../styles/main.scss";

// document.addEventListener("DOMContentLoaded", function () {
//   const blocks = import.meta.glob("../../blocks/**/script.js", { eager: true });
// });
// $('.something').promise().done((self) => { console.log(self); });
// $.when($('.something')).then((self) => { console.log(self); });

jQuery(function() {

    // Moving the GTranslate menu item to the last position for the Main Top Menu
    var menuItemTranslate = jQuery('.nav.top-bar-nav .menu-item-gtranslate');
    // jQuery('.nav.top-bar-nav .menu-item-gtranslate').remove();
    jQuery('.nav.top-bar-nav').append(menuItemTranslate);


    // Moving the Search form to the last position for the Mobile Overlay Menu
    var menuSearchItem = jQuery('.mfp-hide .nav-sidebar li.search-form');
    // jQuery('.mfp-hide .nav-sidebar li.search-form').remove();
    jQuery('.mfp-hide .nav-sidebar').append(menuSearchItem);


    // Copy a Gtranslate menu from the desktop menu and put to the mobile menu
    if (jQuery(window).width() < 850) {
        var gtranslateMenuItem = jQuery('#top-bar .top-bar-nav .menu-item-gtranslate');
        jQuery('.mfp-hide .nav-sidebar li.search-form .header-search-form-wrapper').prepend(gtranslateMenuItem);
    }


    // Adjustment of sorting position for the Shop page
    var sortingWidget = jQuery('.woocommerce-shop .shop-page-title');
    jQuery('.shop-main-header-wrapper').prepend(sortingWidget);

    // Blog/Resources page (/blog) make the search by posts only
    jQuery('.blog-main-header-wrapper .searchform input[name=post_type]').val('post');

    // Search form adjustment (for the Header)
    var searchMenuItem = jQuery('.top-bar-nav li.header-search-form');

    searchMenuItem.find('input').focusout(function(){
        // console.log('Search input is unfocused');
        searchMenuItem.removeClass('is-focused');
    });
    searchMenuItem.find('input').focus(function(){
        // console.log('Search input is focused');
        searchMenuItem.addClass('is-focused');
    });

    // Implementation of counters animation
    const counters = document.querySelectorAll(".counters .row.counter > .col > .col-inner .text > h3");

    const startCounter = (element, end, originalText) => {

        // console.log('Counter is started');

        let current = 0;
        const duration = 3000; // Duration of the counting in milliseconds
        const increment = Math.ceil(end / (duration / 30)); // Calculate increment per tick to complete in about 2 seconds

        const timer = setInterval(() => {

            current += increment; // Increase by calculated increment

            if (current < end) {
                element.textContent = originalText.replace(/\d{1,3}(?:,\d{3})*\+?/, current.toLocaleString("en-US"));
            } else {
                clearInterval(timer);
                element.textContent = originalText.replace(/\d{1,3}(?:,\d{3})*\+?/, end.toLocaleString("en-US") + (originalText.match(/\+$/) ? "+" : ""));
            }

        }, 30);
    };

    const countOnScroll = () => {

        // console.log('On scroll is working');

        let isInViewport = false;
        if ((jQuery(window).scrollTop() + jQuery('.counters').outerHeight() > jQuery('.counters').offset().top)) {
            isInViewport = true;
        }

        counters.forEach((counter) => {
            if (isInViewport && !counter.dataset.counted) {
            const numberMatch = counter.textContent.match(/\d{1,3}(?:,\d{3})*\+?/);
            if (numberMatch) {
                const number = numberMatch[0];
                const cleanNumber = parseInt(number.replace(/,/g, ""), 10);
                startCounter(counter, cleanNumber, counter.textContent);
            }
            counter.dataset.counted = "true"; // Mark as counted to avoid re-running
        }
    });
    };

    if (counters[0] !== undefined) {
        window.addEventListener("scroll", countOnScroll);
        countOnScroll();
    }


    // Forms flow .appear-on-change-form
    if (jQuery('form .appear-on-change-form')[0] !== undefined) {
        jQuery('form .appear-on-change-form').parents('form').find('input').each(function(){
            jQuery(this).on('keyup', function(){
                jQuery(this).parents('form').find('.appear-on-change-form').slideDown(300);
            });
        });
    }

});